import { format, parse } from 'date-fns';
import moment from 'moment';

import { SurveyResponseConfigs } from 'types';

export const getDateForTimeInRoleComputation = (
  input?: SurveyResponseConfigs
) => {
  return (
    input?.position_effective_date ||
    input?.position_start_date ||
    input?.latest_hire_date ||
    input?.original_hire_date
  );
};

export const DATE_FORMATS = {
  std: {
    pikr: 'Y-m-d',
    unicode: 'yyyy-MM-dd',
    printf: '%Y-%m-%d',
    placeholder: 'YYYY-MM-DD',
  },
  'mm/dd/yy': {
    pikr: 'm/d/y',
    unicode: 'MM/dd/yy',
    printf: '%m/%d/%y',
    placeholder: 'MM/DD/YY',
  },
  'mm/dd/yyyy': {
    pikr: 'm/d/Y',
    unicode: 'MM/dd/yyyy',
    printf: '%m/%d/%Y',
    placeholder: 'MM/DD/YYYY',
  },
  'dd/mm/yyyy': {
    pikr: 'd/m/Y',
    unicode: 'dd/MM/yyyy',
    printf: '%d/%m/%Y',
    placeholder: 'DD/MM/YYYY',
  },
  'dd/mm/yy': {
    pikr: 'd/m/y',
    unicode: 'dd/MM/yy',
    printf: '%d/%m/%y',
    placeholder: 'DD/MM/YY',
  },
  //... other formats (what is 'YmdHi' ?)
};

interface DateFormat {
  pikr: string;
  unicode: string;
  printf: string;
  placeholder: string;
}

export const getDateFormatForDatasetTransform = (input: string): DateFormat => {
  if (input in DATE_FORMATS) {
    return DATE_FORMATS[input];
  } else {
    return DATE_FORMATS.std;
  }
};

export const formatDateWithUnicode = (
  date: Date,
  unicodeFormat: string
): string => {
  return format(date, unicodeFormat);
};

export const parseDateFromUnicode = (
  dateStr: string,
  unicodeFormat: string,
  referenceDate?: Date
): Date => {
  if (!referenceDate) {
    referenceDate = new Date();
  }
  return parse(dateStr, unicodeFormat, referenceDate);
};

export const isDateBetween = (
  date: string | Date,
  start: string | Date,
  end: string | Date
): boolean => {
  const d = typeof date === 'string' ? new Date(date) : date;
  const s = typeof start === 'string' ? new Date(start) : start;
  const e = typeof end === 'string' ? new Date(end) : end;
  return d >= s && d <= e;
};

// Check if two date ranges overlap
export const doDateRangesOverlap = (
  start1: string | Date,
  end1: string | Date,
  start2: string | Date,
  end2: string | Date
): boolean => {
  const s1 = typeof start1 === 'string' ? new Date(start1) : start1;
  const e1 = typeof end1 === 'string' ? new Date(end1) : end1;
  const s2 = typeof start2 === 'string' ? new Date(start2) : start2;
  const e2 = typeof end2 === 'string' ? new Date(end2) : end2;
  return s1 <= e2 && e1 >= s2;
};

export const getDatePart = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const monthStr = month > 9 ? `${month}` : `0${month}`;
  const dateStr = day > 9 ? `${day}` : `0${day}`;
  return `${year}-${monthStr}-${dateStr}`;
};

export const relativeDateTime = ({ date }: { date: Date }) => {
  return moment(date).fromNow();
};
